import { Box, Button, Card, CardContent, FormControl, Grid, MenuItem, Paper, TextField } from "@material-ui/core";
import { AccessTime, Call } from "@material-ui/icons";
import React, { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import Swal from "sweetalert2";
import { getBuildingSettingOption } from "../../../../api/buildingSettingApi";
import { getQueueMedication, getQueueRoom, updateCashierQueueMedicineById } from "../../../../api/queueApi";
import Color from "../../../../styles/Color";
import { useForceRender } from "../../../../utils/customHook";
import SelectDropOtions from "../../../components/SelectDropOtions";
import { useStyleFinanceManage } from "./helpers/financeManageEvt";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const initialStateActionDropdown = {
    building: "",
    room: "",
};

const initialMedicineQueue = {
    queueWait: [],
    queueInRoom: {
        cashierQueueId: "",
        QueueNo: "",
        PatientName: "",
        ServingTime: "",
        MedicineStatus: "",
        CollectedTime: "",
    },
    queueHold: [],
    queueWaitPage: 1,
    queueWaitPerPage: 10,
    queueHoldPage: 1,
    queueHoldPerPage: 10,
    totalQueueWait: 0,
    totalQueueHold: 0,
};

export default function ForMedicineManage() {
    const useClass = useStyleFinanceManage();
    const [render, forceRender] = useForceRender();

    // ref
    const controllerRef = useRef(null);

    // component state
    const [socketIO, setSocketIO] = useState(null);
    const [isAllactionDD, setIsAllactionDD] = useState(initialStateActionDropdown);
    const [roomValue, setRoomValue] = useState({ idx: 0, roomObj: {} });
    const [queueTypeTab, setQueueTypeTab] = useState({ idx: 0, type: "Wait" });
    const [option, setOption] = useState({ building: [], floor: [] });
    const [medicineRoom, setMedicineRoom] = useState([]);
    const [medicineQueue, setMedicineQueue] = useState(initialMedicineQueue);
    const [searchQueueText, setSearchQueueText] = useState("");
    const [showMoreIcon, setShowMoreIcon] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRecalling, setIsRecalling] = useState(false);
    const [isCalling, setIsCalling] = useState(false);
    const [callingIndex, setCallingIndex] = useState(null);
    const [isHoldingWaitQueue, setIsHoldingWaitQueue] = useState(false);
    const [holdingWaitQueueIndex, setHoldingWaitQueueIndex] = useState(null);
    const [isClosingHoldQueue, setIsClosingHoldQueue] = useState(false);
    const [closingHoldQueueIndex, setClosingHoldQueueIndex] = useState(null);

    // fetch medicine queue
    const fetchMedicineQueue = async value => {
        try {
            setIsLoading(true);
            const queryParams = {
                locationCode: value?.locationCode,
                roomId: value?.roomId,
                queueStatus: queueTypeTab.type === "Hold" ? "2" : "0",
                queueWaitPage: medicineQueue.queueWaitPage,
                queueWaitPerPage: medicineQueue.queueWaitPerPage,
                queueHoldPage: medicineQueue.queueHoldPage,
                queueHoldPerPage: medicineQueue.queueHoldPerPage,
                search: searchQueueText,
            };
            const res = await getQueueMedication(queryParams, controllerRef.current?.signal);
            if (res) {
                setMedicineQueue(currentState => ({
                    ...currentState,
                    queueWait: queueTypeTab.type === "Wait" ? res?.patientWait : [],
                    queueHold: queueTypeTab.type === "Hold" ? res?.patientHold : [],
                    queueInRoom: {
                        cashierQueueId: res?.patientInRoom?.cashierQueueId || "",
                        QueueNo: res?.patientInRoom?.QueueNo || "",
                        PatientName: res?.patientInRoom?.PatientName || "",
                        ServingTime: "",
                        MedicineStatus: res?.patientInRoom?.MedicineStatus || "",
                        CollectedTime: res?.patientInRoom?.CollectedTime || "",
                    },
                    totalQueueWait: res?.totalQueueWait || 0,
                    totalQueueHold: res?.totalQueueHold || 0,
                }));
            }
            setIsLoading(false);
        } catch (error) {
            console.dir(error);
            setIsLoading(false);
        }
    };

    // fetch medicine room
    const fetchRoom = async (building = null, floor = null) => {
        try {
            const queryParams = {
                builingId: building ? building : 0,
                floorId: floor ? floor : 0,
                statusRoom: "1",
            };
            const res = await getQueueRoom(queryParams, controllerRef.current?.signal);
            if (res) {
                setMedicineRoom(res?.data);
                if (res?.data?.length > 0) {
                    setRoomValue({ idx: 0, roomObj: res?.data[0] });
                    handleSelectRoom(0, res?.data[0]);
                } else {
                    setMedicineQueue(initialMedicineQueue);
                }
            }
        } catch (error) {
            console.dir(error);
        }
    };

    // fetch building setting option
    const fetchBuildingSettingOption = async signal => {
        try {
            const buildingSettingOption = await getBuildingSettingOption(signal);
            if (buildingSettingOption) {
                setOption(currentState => ({
                    ...currentState,
                    building: buildingSettingOption?.buildingOption,
                    floor: buildingSettingOption?.floorOption,
                }));
            }
        } catch (error) {
            console.dir(error);
        }
    };

    // update medicine queue
    const handleUpdateMedicineQueueStatus = async value => {
        const isUpdate = await updateCashierQueueMedicineById(
            value?.id,
            { MedicineStatus: value?.MedicineStatus, MedicineRoom: value?.MedicineRoom },
            controllerRef.current?.signal,
        );
        if (isUpdate) {
            socketIO.emit("update-medicine-queue", {
                type: ["1"].includes(value?.MedicineStatus) ? "" : "without-voice",
                QueueNo: value?.QueueNo,
            });
            forceRender();
        }
    };

    // select medicine room
    const handleSelectRoom = async (idx, roomObj) => {
        setMedicineQueue(initialMedicineQueue);
        setSearchQueueText("");
        if (roomObj) {
            setRoomValue({ idx, roomObj });
        }
    };

    // change tab
    const handleChangeTab = (idx, type) => {
        setMedicineQueue(initialMedicineQueue);
        setSearchQueueText("");
        setQueueTypeTab({ idx, type });
    };

    // search filter
    const handleSearchQueue = search => {
        setSearchQueueText(search);
    };

    // click search
    const handleClickSearch = () => {
        forceRender();
    };

    // clear search
    const handleClearSearch = () => {
        setSearchQueueText("");
        forceRender();
    };

    // select building and floor
    const handleOnchangeDropdown = async (type = "", value = "") => {
        handleSelectRoom(0, {});
        setSearchQueueText("");
        if (type === "building") {
            setIsAllactionDD({ ...isAllactionDD, building: value, floor: "" });
            setMedicineRoom([]);
        } else if (type === "floor") {
            setIsAllactionDD({ ...isAllactionDD, floor: value });
            fetchRoom(isAllactionDD?.building, value);
        }
    };

    // click action button 'hold' and 'close'
    const handleClickActionQueue = async (type, data) => {
        if (type === "hold") {
            Swal.fire({
                heightAuto: false,
                title: `<div class="h3 t-text-primary">Want to hold this queue?</div>`,
                iconHtml: '<i class="far fa-clock fa-lg" style="color:inherit;" ></i>',
                iconColor: Color.primary,
                text: "",
                showCancelButton: true,
                confirmButtonColor: Color.primary,
                cancelButtonColor: "#7C7C7C",
                confirmButtonText: "YES",
                cancelButtonText: "NO",
                customClass: {
                    icon: "border-0 t-icon-show",
                },
            }).then(async result => {
                if (result.isConfirmed) {
                    const updateBody = {
                        id: data?.cashierQueueId,
                        MedicineStatus: "2",
                        MedicineRoom: data?.MedicineRoom,
                    };
                    handleUpdateMedicineQueueStatus(updateBody);
                }
            });
        } else if (type === "close") {
            Swal.fire({
                heightAuto: false,
                icon: "success",
                title: `<div class="h3 t-text-primary">Want to close this queue?</div>`,
                iconColor: Color.primary,
                text: "",
                showCancelButton: true,
                confirmButtonColor: Color.primary,
                cancelButtonColor: "#7C7C7C",
                confirmButtonText: "YES",
                cancelButtonText: "NO",
            }).then(result => {
                if (result.isConfirmed) {
                    const updateBody = {
                        id: data?.cashierQueueId,
                        MedicineStatus: "3",
                        MedicineRoom: data?.MedicineRoom,
                    };
                    handleUpdateMedicineQueueStatus(updateBody);
                }
            });
        }
    };

    // click call
    const handleClickCall = async (value, index) => {
        setCallingIndex(index);
        setIsCalling(true);
        if (medicineQueue?.queueInRoom?.QueueNo === "") {
            const updateBody = {
                id: value?.cashierQueueId,
                QueueNo: value?.QueueNo,
                MedicineStatus: "1",
                MedicineRoom: roomValue?.roomObj?.roomId,
            };
            await handleUpdateMedicineQueueStatus(updateBody);
        } else {
            Swal.fire({
                heightAuto: false,
                title: `<div class="h3 t-text-primary">The patient is already in the medicine room.</div>`,
                iconHtml: '<i class="far fa-clock fa-lg" style="color:inherit;" ></i>',
                iconColor: Color.primary,
                text: "",
                showCancelButton: false,
                confirmButtonColor: Color.primary,
                cancelButtonColor: "#7C7C7C",
                confirmButtonText: "YES",
                customClass: {
                    icon: "border-0 t-icon-show",
                },
            });
        }
        setIsCalling(false);
    };

    // click hold in wait queue
    const handleClickHoldWaitQueue = async (value, index) => {
        const { isConfirmed } = await Swal.fire({
            title: `<div class="h3 t-text-primary">Want to hold this queue?</div>`,
            iconHtml: '<i class="far fa-clock fa-lg" style="color:inherit;" ></i>',
            iconColor: Color.primary,
            text: "",
            showCancelButton: true,
            confirmButtonColor: Color.primary,
            cancelButtonColor: "#7C7C7C",
            confirmButtonText: "YES",
            cancelButtonText: "NO",
            heightAuto: false,
            customClass: {
                icon: "border-0 t-icon-show",
            },
        });
        if (isConfirmed && value?.cashierQueueId) {
            setHoldingWaitQueueIndex(index);
            setIsHoldingWaitQueue(true);
            const updateBody = {
                id: value?.cashierQueueId,
                MedicineStatus: "2",
                MedicineRoom: null,
            };
            await handleUpdateMedicineQueueStatus(updateBody);
        }
        setIsHoldingWaitQueue(false);
    };

    // click close in hold queue
    const handleClickCloseHoldQueue = async (value, index) => {
        const { isConfirmed } = await Swal.fire({
            heightAuto: false,
            icon: "success",
            title: `<div class="h3 t-text-primary">Want to close this queue?</div>`,
            iconColor: Color.primary,
            text: "",
            showCancelButton: true,
            confirmButtonColor: Color.primary,
            cancelButtonColor: "#7C7C7C",
            confirmButtonText: "YES",
            cancelButtonText: "NO",
        });
        if (isConfirmed && value?.cashierQueueId) {
            setClosingHoldQueueIndex(index);
            setIsClosingHoldQueue(true);
            const updateBody = {
                id: value?.cashierQueueId,
                MedicineStatus: "3",
                MedicineRoom: null,
            };
            await handleUpdateMedicineQueueStatus(updateBody);
        }
        setIsClosingHoldQueue(false);
    };

    // click recall
    const handleClickRecall = () => {
        setIsRecalling(true);
        socketIO.emit("update-medicine-queue", {
            type: "",
            QueueNo: medicineQueue?.queueInRoom?.QueueNo,
        });
        setTimeout(() => {
            setIsRecalling(false);
        }, 500);
    };

    // click more queue icon
    const handleFetchMoreQueue = () => {
        setMedicineQueue(currentState => ({
            ...currentState,
            queueWaitPage: queueTypeTab.type === "Wait" ? currentState.queueWaitPage + 1 : currentState.queueWaitPage,
            queueHoldPage: queueTypeTab.type === "Hold" ? currentState.queueHoldPage + 1 : currentState.queueHoldPage,
        }));
    };

    useEffect(() => {
        if (roomValue.roomObj?.roomId) {
            fetchMedicineQueue({
                locationCode: roomValue?.roomObj?.Floor?.locationCode,
                roomId: roomValue?.roomObj?.roomId,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roomValue, queueTypeTab, medicineQueue.queueWaitPage, medicineQueue.queueHoldPage, render]);

    useEffect(() => {
        if (queueTypeTab.type === "Wait" && medicineQueue.queueWait.length !== medicineQueue.totalQueueWait) {
            setShowMoreIcon(true);
        } else if (queueTypeTab.type === "Hold" && medicineQueue.queueHold.length !== medicineQueue.totalQueueHold) {
            setShowMoreIcon(true);
        } else {
            setShowMoreIcon(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queueTypeTab, medicineQueue.queueWait, medicineQueue.queueHold]);

    // fetch building option data
    useEffect(() => {
        controllerRef.current = new AbortController();
        fetchBuildingSettingOption();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, []);

    // connect socket.io
    useEffect(() => {
        let socket;
        if (roomValue?.roomObj?.floorId) {
            socket = io(`${process.env?.REACT_APP_HOST_SOCKET}/medicine-queue`, {
                transports: ["websocket"],
            });

            socket.on("connect", () => {
                socket.emit("join-medicine-room", roomValue?.roomObj?.floorId);
            });

            socket.on("medicine-queue-from-update", () => {
                forceRender();
            });

            socket.on("medicine-queue-from-hch", () => {
                forceRender();
            });

            setSocketIO(socket);
        }

        return () => {
            if (roomValue?.roomObj?.floorId && socket) {
                socket.off("connect");
                socket.off("medicine-queue-from-update");
                socket.off("medicine-queue-from-hch");
                socket.emit("leave-medicine-room");
            }
        };
    }, [roomValue.roomObj, forceRender]);

    return (
        <div className="h-100 flex-column d-flex">
            {/* navbar menu floor and room */}
            <div className="flex-grow-0">
                <Grid container spacing={1} className="justify-content-lg-start mb-5">
                    <Grid item xs={12} md={2}>
                        <SelectDropOtions
                            key={"select_floor"}
                            options={option?.building}
                            useTheme={true}
                            onChange={value => handleOnchangeDropdown("building", value)}
                            value={isAllactionDD?.building}
                            placeholder="Select..."
                            renderOption={row => {
                                return (
                                    <MenuItem key={"floor_" + row.buildingId} value={row.buildingId}>
                                        {" "}
                                        {row.name}{" "}
                                    </MenuItem>
                                );
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <SelectDropOtions
                            key={"select_room"}
                            options={option?.floor.filter(item => item?.buildingId === isAllactionDD?.building)}
                            useTheme={true}
                            onChange={value => handleOnchangeDropdown("floor", value)}
                            value={isAllactionDD?.floor}
                            placeholder="Select..."
                            renderOption={row => {
                                return (
                                    <MenuItem key={"room_" + row.floorId} value={row.floorId}>
                                        {" "}
                                        {row.name} {row.locationName}
                                    </MenuItem>
                                );
                            }}
                        />
                    </Grid>
                </Grid>
            </div>

            <div style={{ height: 0 }} className="flex-fill d-flex flex-column">
                <div className="flex-grow-0">
                    <Grid container spacing={1} className="justify-content-lg-start">
                        <Grid item xs={12}>
                            <div className="row">
                                <div className="col-12">
                                    <div
                                        className="d-flex align-items-center"
                                        style={{ overflowX: "auto", overflowY: "hidden" }}>
                                        {medicineRoom?.map((row, idx) => (
                                            <div key={"room_" + idx} className="col-4 col-sm-3 col-lg-2 px-0">
                                                <div
                                                    className={`${useClass.boxlistRoom} ${
                                                        roomValue.idx === idx ? "active" : ""
                                                    }`}
                                                    onClick={() => handleSelectRoom(idx, row)}>
                                                    <p className="text-typo">
                                                        {row?.name} {row?.locationName}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>

                {/* content */}
                <div className="flex-fill" style={{ height: 0 }}>
                    <Paper elevation={1} className="p-5 h-100">
                        <Grid container spacing={2} className="h-100">
                            {/* result show */}
                            <Grid item xs={12} lg={5}>
                                <Box
                                    // style={{ height: heightBox }}
                                    className={`h-100 d-flex flex-column justify-content-between text-center shadow-xs rounded rounded-lg overflow-auto ${useClass.boxContentFixed}`}>
                                    {/* <div className={`t-card-title ${useClass.titleCard}`}></div> */}
                                    <div className="mb-5 mb-lg-10">
                                        <h3 className="text-muted mb-5">Queue Number</h3>
                                        <h3 className="t-text-primary">{medicineQueue?.queueInRoom?.QueueNo ?? "-"}</h3>
                                    </div>
                                    <div className="mb-5 mb-lg-10">
                                        <h3 className="text-muted mb-5">Patient</h3>
                                        <h3 className="t-text-primary">
                                            {medicineQueue?.queueInRoom?.PatientName ?? "-"}
                                        </h3>
                                    </div>
                                    <div className="mb-5 mb-lg-10">
                                        <h3 className="text-muted mb-5">Serving Time</h3>
                                        <h3 className="t-text-primary">
                                            {" "}
                                            {medicineQueue?.queueInRoom?.CollectedTime ?? "-"}
                                        </h3>
                                    </div>
                                    <div className="mb-5 mb-lg-10">
                                        <h3 className="text-muted mb-5">Status</h3>
                                        <h3 className="t-text-primary">
                                            {" "}
                                            {medicineQueue?.queueInRoom?.MedicineStatus === "1" ? "ถูกเรียกรับยา" : "-"}
                                        </h3>
                                    </div>
                                    {medicineQueue?.queueInRoom?.QueueNo ? (
                                        <div className="d-flex justify-content-center align-items-center">
                                            <Button
                                                onClick={handleClickRecall}
                                                className={`t-btn-primary mb-5 mb-lg-10`}
                                                style={{ width: "40%", height: "70%" }}>
                                                {isRecalling ? (
                                                    <div
                                                        className="spinner-border"
                                                        style={{ width: "1.5rem", height: "1.5rem" }}
                                                        role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                ) : (
                                                    "Recall"
                                                )}
                                            </Button>
                                        </div>
                                    ) : null}
                                </Box>
                            </Grid>
                            {/* actions */}
                            <Grid item xs={12} lg={2}>
                                <div className="h-100 d-flex flex-column justify-content-center align-items-center">
                                    <Button
                                        className={`${useClass.btnAcStatus} active`}
                                        onClick={() => {
                                            handleClickActionQueue("hold", medicineQueue?.queueInRoom);
                                        }}>
                                        Hold
                                    </Button>
                                    <Button
                                        className={`${useClass.btnAcStatus} active`}
                                        onClick={() => {
                                            handleClickActionQueue("close", medicineQueue?.queueInRoom);
                                        }}>
                                        Close
                                    </Button>
                                </div>
                            </Grid>
                            {/* data list */}
                            <Grid item xs={12} lg={5}>
                                <Box
                                    // style={{ height: heightBox }}
                                    className={`h-100 shadow-xs rounded rounded-lg overflow-hidden d-flex flex-column ${useClass.boxContentFixed}`}>
                                    {/* <div className={`t-card-title ${useClass.titleCard}`}>Queue Waiting</div> */}
                                    <div className="d-flex align-items-center">
                                        {["Wait", "Hold"]?.map((row, idx) => (
                                            <div key={"queue_type_" + idx} className="flex-fill">
                                                <div
                                                    className={`${useClass.boxlistQueue} ${
                                                        queueTypeTab.idx === idx ? "active" : ""
                                                    }`}
                                                    onClick={() => handleChangeTab(idx, row)}>
                                                    <p className="text-typo">{row}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="p-5 d-flex justify-content-center align-items-center">
                                        <FormControl className="t-form-group-custom w-100 mr-2">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                type="text"
                                                label="Search Queue"
                                                variant="outlined"
                                                value={searchQueueText}
                                                onChange={e => handleSearchQueue(e.target.value)}
                                            />
                                        </FormControl>
                                        <Button onClick={handleClickSearch} className="t-btn-primary mr-2">
                                            Search
                                        </Button>
                                        <Button onClick={handleClearSearch} className="t-btn-primary">
                                            Clear
                                        </Button>
                                    </div>
                                    <div
                                        style={{ height: 0 }}
                                        className={`flex-fill overflow-auto ${useClass.boxListUserWait}`}>
                                        {(queueTypeTab.type === "Wait"
                                            ? medicineQueue?.queueWait
                                            : medicineQueue?.queueHold
                                        )?.map((row, idx, array) => {
                                            return (
                                                <div key={"list_" + idx}>
                                                    <Card elevation={0} className="border-bottom card-list-users">
                                                        <CardContent className="p-3 px-10">
                                                            <div className="row">
                                                                <div className="col-7">
                                                                    <p className="mb-2">
                                                                        {row?.PatientName} ({row?.QueueNo})
                                                                    </p>
                                                                    <p className="t-text-orange mb-2">
                                                                        {row?.MedicineStatus === "2"
                                                                            ? "Status : Hold"
                                                                            : ""}
                                                                    </p>
                                                                    <p className="mb-2 d-flex align-items-center">
                                                                        <Call
                                                                            className="mr-1 t-text-primary"
                                                                            color="primary"
                                                                        />
                                                                        {row?.UserMobile?.phoneNumber}
                                                                    </p>
                                                                </div>
                                                                <div className="col-5">
                                                                    <div className="d-flex align-items-center">
                                                                        <Button
                                                                            onClick={() => handleClickCall(row, idx)}
                                                                            className="t-btn-primary w-100 mr-1"
                                                                            disabled={isCalling}>
                                                                            {isCalling && callingIndex === idx ? (
                                                                                <div
                                                                                    className="spinner-border"
                                                                                    style={{
                                                                                        width: "1.5rem",
                                                                                        height: "1.5rem",
                                                                                    }}
                                                                                    role="status">
                                                                                    <span className="sr-only">
                                                                                        Loading...
                                                                                    </span>
                                                                                </div>
                                                                            ) : (
                                                                                "Call"
                                                                            )}
                                                                        </Button>
                                                                        {row?.MedicineStatus !== "2" ? (
                                                                            <Button
                                                                                onClick={() => {
                                                                                    handleClickHoldWaitQueue(row, idx);
                                                                                }}
                                                                                className="t-btn-primary w-100 mr-1"
                                                                                disabled={isHoldingWaitQueue}>
                                                                                {isHoldingWaitQueue &&
                                                                                holdingWaitQueueIndex === idx ? (
                                                                                    <div
                                                                                        className="spinner-border"
                                                                                        style={{
                                                                                            width: "1.5rem",
                                                                                            height: "1.5rem",
                                                                                        }}
                                                                                        role="status">
                                                                                        <span className="sr-only">
                                                                                            Loading...
                                                                                        </span>
                                                                                    </div>
                                                                                ) : (
                                                                                    "Hold"
                                                                                )}
                                                                            </Button>
                                                                        ) : (
                                                                            <Button
                                                                                onClick={() => {
                                                                                    handleClickCloseHoldQueue(row, idx);
                                                                                }}
                                                                                className="t-btn-primary w-100 mr-1"
                                                                                disabled={isClosingHoldQueue}>
                                                                                {isClosingHoldQueue &&
                                                                                closingHoldQueueIndex === idx ? (
                                                                                    <div
                                                                                        className="spinner-border"
                                                                                        style={{
                                                                                            width: "1.5rem",
                                                                                            height: "1.5rem",
                                                                                        }}
                                                                                        role="status">
                                                                                        <span className="sr-only">
                                                                                            Loading...
                                                                                        </span>
                                                                                    </div>
                                                                                ) : (
                                                                                    "Close"
                                                                                )}
                                                                            </Button>
                                                                        )}
                                                                        <small className="text-muted d-flex align-items-center justify-content-end">
                                                                            <AccessTime className="mr-1" />
                                                                            {row?.waitQueue || 0}
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardContent>
                                                    </Card>
                                                    {idx === array.length - 1 &&
                                                        showMoreIcon &&
                                                        (isLoading ? (
                                                            <div className="d-flex justify-content-center align-items-center py-5">
                                                                <div className="spinner-border" role="status">
                                                                    <span className="sr-only">Loading...</span>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className="w-100 d-flex justify-content-center align-items-center load-more-data"
                                                                onClick={handleFetchMoreQueue}>
                                                                <ExpandMoreIcon style={{ fontSize: 50 }} />
                                                            </div>
                                                        ))}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                </div>
            </div>
        </div>
    );
}
